import React from "react";
import { formatDefaultDateTime } from "../../common/utils/time.formatted.util";
import { howLongUntilDate } from "../../utils/time.util";
import Tag from "./Tag";

const TimeTag = function TimeIndicator({
    time,
    label,
}: {
    time: Date | null | undefined;
    label?: string;
}) {
    const now = new Date();
    const timeAsDate = time || null;

    if (!timeAsDate) return null;

    const isInThePast = timeAsDate < now;
    const { quantity, timePeriod } = isInThePast
        ? howLongUntilDate(timeAsDate, now)
        : howLongUntilDate(now, timeAsDate);
    const isQuantityMoreThanOne = quantity > 1;
    let agoPostfix = isInThePast ? "ago" : undefined;
    let inPrefix = !isInThePast ? "in" : undefined;

    let timeFormatted = "";
    switch (timePeriod) {
        case "minute": {
            const appendix = isQuantityMoreThanOne ? "minutes" : "minute";
            timeFormatted = `${quantity} ${appendix}`;
            break;
        }
        case "hour": {
            const appendix = isQuantityMoreThanOne ? "hours" : "hour";
            timeFormatted = `${quantity} ${appendix}`;
            break;
        }
        case "day": {
            const appendix = isQuantityMoreThanOne ? "days" : "day";
            timeFormatted = `${quantity} ${appendix}`;
            break;
        }
        case "dateInMilliseconds":
            timeFormatted = formatDefaultDateTime(new Date(quantity));
            agoPostfix = undefined;
            inPrefix = undefined;
            break;
        default:
            break;
    }

    const fullLabel = [label, inPrefix, timeFormatted, agoPostfix]
        .filter(Boolean)
        .join(" ");

    return <Tag.XSmall.DeadlinePrio3>{fullLabel}</Tag.XSmall.DeadlinePrio3>;
};

export default TimeTag;
